import { checkHttpStatus, getBaseUrl, getApiHeaders } from '../utils'

export const FORGOT_PASSWORD_REQUEST = 'FORGOT_PASSWORD_REQUEST'
export const FORGOT_PASSWORD_SUCCESS = 'FORGOT_PASSWORD_SUCCESS'

export function forgotPasswordSuccess(): Action {
  return {
    type: FORGOT_PASSWORD_SUCCESS
  }
}

export function forgotPasswordRequest(): Action {
  return {
    type: FORGOT_PASSWORD_REQUEST
  }
}

export function forgotPassword(email: string): Function {
  return async (dispatch, getState) => {
    const state = getState()
    const url = `${getBaseUrl()}/quest_maker/api/password_resets`
    dispatch(forgotPasswordRequest())
    localStorage.setItem('lastLogin', email)
    try {
      checkHttpStatus(
        await fetch(url, {
          method: 'POST',
          headers: getApiHeaders(state),
          body: JSON.stringify({
            email: email
          })
        })
      )
      dispatch(forgotPasswordSuccess())
    } catch (error) {
      console.log(error)
    }
  }
}



// WEBPACK FOOTER //
// ./src/actions/forgotpassword.js